import Redirect from "../common/Redirect";
import { useSelector } from "react-redux";
import Layout from "../layout/customer/public";

const ProtectUserRoute = (props) => {
  const { auth } = useSelector((state) => state.customerAuth);

  if (auth.isAuthenticated) {
    return <Layout />;
  } else {
    return <Redirect route="/login" />;
  }
};
export default ProtectUserRoute;
